import React, { memo } from 'react';

const IndexPage = () => (
  <>
    <div />
  </>
);

export default memo(IndexPage);
